import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { MainComponent } from './shared/components/main';
import { NoPermissionComponent } from './shared/components/no-permission/no-permission.component';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./modules/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
      },
      {
        path: 'unauthorized',
        component: NoPermissionComponent,
      },
      // {
      //   path: 'roles-and-permissions',
      //   loadChildren: () =>
      //     import(
      //       './modules/roles-and-permissions/roles-and-permissions.module'
      //     ).then((m) => m.RolesAndPermissionsModule),
      // },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
